import { NgxPageSize } from './ngxGrid/ngxPageSize.component';
import { NgxRefresh } from './ngxGrid/ngxRefresh.component';
import { NgxToggleColumn } from './ngxGrid/ngxToggleColumn.component';
import { PrintPage } from './print/print.page';
import { PrintPreview } from './print/print.preview';
// import { HeaderInterceptor } from './http-interceptor/http-interceptor';

export const SHARED_COMPONENTS: any[] = [
	NgxPageSize,
	NgxRefresh,
	NgxToggleColumn,
	PrintPage,
	PrintPreview,
	// HeaderInterceptor
];

export * from './ngxGrid/ngxPageSize.component';
export * from './ngxGrid/ngxRefresh.component';
export * from './ngxGrid/ngxToggleColumn.component';
export * from './print/print.page';
export * from './print/print.preview';
// export * from './http-interceptor/http-interceptor';



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/index.ts